import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-16 lg:py-20 bg-gradient-to-br from-link-navy via-blue-900 to-link-blue relative overflow-hidden" data-id="element-82">
      {/* Abstract Background Elements */}
      <div className="absolute inset-0 opacity-20" data-id="element-83">
        <div className="absolute top-0 left-0 w-full h-full bg-[url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9IiNGRkZGRkYiLz48L3N2Zz4=')]" data-id="element-84" />
      </div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-cyan-400 rounded-full blur-[120px] opacity-50" data-id="element-85" />
      <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-blue-600 rounded-full blur-[120px] opacity-50" data-id="element-86" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-87">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-4xl mx-auto text-center" data-id="element-88">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight" data-id="element-89">
            Deja de aprender en desorden
          </h2>
          <p className="text-2xl md:text-3xl font-semibold text-blue-100 mb-8 leading-tight" data-id="element-90">
            Construye tu ruta digital con Link Academy
          </p>
          <p className="text-xl text-blue-100 mb-12 max-w-2xl mx-auto leading-relaxed" data-id="element-91">
            Únete a una comunidad donde aprendes, aplicas y creces con ayuda de
            inteligencia artificial.
          </p>

          <a href="https://www.skool.com/link-academy-1317" target="_blank" rel="noopener noreferrer" className="inline-flex justify-center items-center gap-2 bg-white hover:bg-gray-50 text-link-navy px-10 py-5 rounded-full font-bold text-xl transition-all shadow-2xl hover:shadow-white/20 hover:-translate-y-1 group" data-id="element-92">
            Entrar a Skool
            <ArrowRight className="group-hover:translate-x-1 transition-transform" size={24} data-id="element-93" />
          </a>
        </motion.div>
      </div>
    </section>;
}